import { useEffect, useState } from "react";
import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import { Grid, GridColumn, GridDataStateChangeEvent, } from "@progress/kendo-react-grid";
import { Link, useNavigate, useParams } from "react-router-dom";
import WorkHourService from "../../Shared/Services/WorkHourService";
import { ColumnMenuDefaultFilter } from "../../Shared/Components/ColumnMenuFilter";
import SweetAlertService from "../../../../services/SweetAlertService";
import { DeletePopupConfirmationMessage } from "../../Shared/Constants/AdminModuleConstants";
import "../WorkHour.css";

export const WorkHourDetailList = () => {
    const { id } = useParams();
    let initialState = { dataState: { skip: 0, take: 20 }, result: { data: [], total: 0 } };
    const navigate = useNavigate();

    const [result, setResult] = useState<DataResult>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);
    const [headerData, setHeaderData] = useState<any>();

    useEffect(() => {
        fetchData(dataState);
        getWorkHourData(id);
    }, []);

    const getWorkHourData = (id: any) => {
        WorkHourService.getWorkHourById(id)
            .then((response: any) => {
                setHeaderData(response.data);
            })
    };

    const fetchData = (state: State) => {
        const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
        WorkHourService.getWorkHourDetails(queryStr, id)
            .then((response) => {
                setResult({ data: response.data.data, total: response.data.total });
                setDataState(state);
            });
    }

    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
        fetchData(event.dataState);
    };

    const renderActionCell = (props: any) => {
        return (
            <td>
                <a className="btn btn-primary btn-sm" onClick={() => navigate(`/updateWorkhourDetails/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-edit k-icon-color"></span>
                </a>
                <a className="btn btn-primary btn-sm ms-1" onClick={() => navigate(`/viewWorkhourDetails/${props.dataItem.id}`)}>
                    <span className="k-icon k-i-information k-icon-color"></span>
                </a>
                <a className="btn btn-primary btn-sm ms-1" onClick={() => onDelete(props.dataItem.id)}>
                    <span className="k-icon k-i-delete k-icon-color"></span>
                </a>
            </td>
        );
    };

    const onDelete = (id: any) => {
        SweetAlertService.confirm('Delete', DeletePopupConfirmationMessage).then((res: any) => {
            if (res.isConfirmed) {
                WorkHourService.deleteWorkHourDetailsById(id).then((res) => {
                    if (res) {
                        fetchData(dataState);
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
        })
    }

    return (
        <>
            <div className="card card-default">
                <div className="card-header">
                    <h4><Link className="custom-nav-link" to="/workhour"> Session rates for {headerData?.countryName}-{headerData?.contract}-{headerData?.role}-{headerData?.subRole} contract</Link>
                        <button
                            title="Add new"
                            className="btn btn-primary pull-right"
                            onClick={() => navigate(`/addWorkhourDetails/${id}`)}>
                            Create session rate
                        </button>
                    </h4>
                </div>
                <div className="card-body card-body-custom">
                    <Grid
                        sortable={true}
                        pageable={{
                            buttonCount: 4,
                            pageSizes: [5, 10, 15, 20],
                        }}
                        {...dataState}
                        data={result}
                        onDataStateChange={dataStateChange}>
                        <GridColumn field="workHourTypeName" title="Work Hour Type" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                        <GridColumn field="startTime" title="Start Time" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                        <GridColumn field="endTime" title="End Time" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                        <GridColumn field="sessionLength" title="Session Length" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                        <GridColumn title="Action" cell={renderActionCell} width="200px" />
                    </Grid>
                </div>
            </div>
        </>
    )
}